export const VALIDATION_MODAL_CONSTANTS = {
  UPDATE: 'Update',
  BACK: 'Back',
  CONFIRMATION_TEXT: 'Add scope value for the reporting year',
  SUB_INFO_TEXT: `Please complete your processing facility scope data for the selected reporting year, before creating a product.`,
};
